var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-mobile-autocomplete',{attrs:{"value":_vm.internal_value,"items":_vm.items,"search":_vm.doSearch,"label":_vm.label,"placeholder":"Search RedChirp users"},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }